import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../utils/firebase'

// One document per waitlist signup, keyed by normalized email — this makes
// "already joined" detection automatic and free: Firestore rules reject a
// second create at the same document ID, no separate duplicate check needed.
// Two different forms call this (the full Waitlist section: name+email+city,
// and the footer's quick email-only capture), so name/city always default to
// '' rather than being required — keeps one shape for both call sites.
export const joinWaitlist = async ({ name = '', email, city = '', source }) => {
    const normalizedEmail = email.trim().toLowerCase()
    try {
        await setDoc(doc(db, 'waitlist', normalizedEmail), {
            name: name.trim(),
            email: normalizedEmail,
            city,
            source,
            createdAt: serverTimestamp(),
        })
    } catch (err) {
        // Firestore rules reject this exact write if the email already exists
        // (see FIRESTORE-RULES.md) — that's not a real error, it just means
        // this person already joined. Normalize it to the same shape the old
        // backend's 409-duplicate response used, so existing call sites that
        // check err.response.status === 409 keep working unchanged.
        if (err.code === 'permission-denied') {
            const duplicateError = new Error('Already on the waitlist')
            duplicateError.response = { status: 409, data: { message: 'You are already on the waitlist.' } }
            throw duplicateError
        }
        throw err
    }
}
